import React, { useState, useContext, useEffect, useRef } from 'react';
import './GameBoard.css';
import '../src/styles/font.css';
import Xarrow from 'react-xarrows';

import TerritoryButton from './TerritoryButton';
import mapImage from './Assets/Images/GameBoard/PlayScreen.png';
import GameBoardData from './GameBoardData';
import { ScreenContext } from './App';

// Import AIController
//import aiController from './AIController'; // Adjust the path as per your file structure
//import { executeBotAI } from './AIController';
//import { executeBotAIExport } from './AIController';
import AIController, { executeBotAIExport, updateAIActiveStatusExport } from './AIController';

// GamePlay Icons Imports
import zoomBar from "./Assets/Images/GameBoard/GamePlayIcons/ZoomControls/zoomSlider-plu.png";
import zoomBarMinus from "./Assets/Images/GameBoard/GamePlayIcons/ZoomControls/zoomSlider-minus.png";

import flagBtn from './Assets/Images/GameBoard/GamePlayIcons/Icon1.png';
import settingBtn from './Assets/Images/GameBoard/GamePlayIcons/Icon2.png';
import helpBtn from './Assets/Images/GameBoard/GamePlayIcons/Icon3.png';

import arrowIndicator from './Assets/Images/GameBoard/GamePlayIcons/possibleMoveArrow.png';
//import targetIndicator from './Assets/Images/GameBoard/GamePlayIcons/target.png';
import Alaska from './Assets/Images/GameBoard/WorldMap/Alaska/AlaskaBlue.png';
import NorthWest from './Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritoryBlue.png';

// Local Player Profile Sprites

import profileHolderBG from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/profileDataHolderBG.png';
import phaseStatusSprite from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/terriotryPhaseIcon.png';
import timerSpriteBG from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/timerSpriteBG.png';
import timerSprite from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/timerSprite.png';
import playerProfile from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/playerProfile.png';
import playerProfileLevel from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/LocalPlayerCountBG.png';

// Action Icons
import wrongBtn from './Assets/Images/GameBoard/WrongBtn.png';
import rightBtn from './Assets/Images/GameBoard/RightBtn.png';

// Troops Selection Bar 
import overlayImage from './Assets/Images/GameBoard/OverlayImage.png';
import selectionBG from './Assets/Images/AppDashboard/PlayerSelectionScreen/selectionBG.png';
import descreaseeBtn from './Assets/Images/AppDashboard/PlayerSelectionScreen/decreaseBtn.png';
import increaseBtn from './Assets/Images/AppDashboard/PlayerSelectionScreen/increaseBtn.png';

// Player Turn Sprites
import playerTurnBG from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player1Icons/playerTurnBackground.png';
import player2Profile from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player2Icons/Player2Profile.png';
import player2TurnBG from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player2Icons/playerTurnBackground.png';
import player3Profile from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player3Icons/Player3Profile.png';
import player3TurnBG from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player3Icons/playerTurnBackground.png'
import player4TurnBG from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player4Icons/playerTurnBackground.png'
import player5TurnBG from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player5Icons/playerTurnBackground.png'
import player6TurnBG from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player6Icons/playerTurnBackground.png'

import playerTimerClock from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/timerClock.png';

// Game End Sprites
import victoryScreen from './Assets/Images/GameBoard/VictoryScreen.png';
import defeatScreen from './Assets/Images/GameBoard/DefeatScreen.png';

// Battle Screen
import BattleScreen from './BattleScreen';
import { isBattleScreenClosedExport, handleZIndexChangeExport, initializeBattleScreenDataExport, BattleDataExport } from './BattleScreen';

// Forfiet Screen
import ForFiet from './Forfiet';
import {handleForfietZIndexChangeExport} from './Forfiet.jsx';

// Splash Screen
import SplashScreen from './SplashScreen';

// Setting Screen

import SettingScreen from './SettingScreen';
import {handleSettingZIndexChangeExport} from './SettingScreen';

let PlayersDataExport;
let currentPhaseExport;

let territoryBoardDataExport;
let linkingTerritoriesExport;
let currentTurnPlayerExport;

let updateTerritoryDataExport;
let updatePlayerDataExport;

let movePhaseExport;
let setCurrentGameStateExport;

let rollDiceExport;
let attackerDiceNumberExport;
let defenderDiceNumberExport;
let setAttackerDiceNumberExport;
let setDefenderDiceNumberExport;

let removeTerritoryFromOtherPlayersExport;
let isLogModeOnExport;

let InitializeGameBoardExport;

let battleResultDataExport;
let SetBattleResultDataExport;

let restoreAttackTimerExport;
let phaseTimerExport;

// Player Profiles

let playerProfile1;
let playerProfile2;
let playerProfile3;

const GameBoard = () => {

  // console.log('Game Board Script Loaded');

  const [imageWidth, setImageWidth] = useState("100%"); // Initial width of the image
  const [scaleCss, setScaleCss] = useState(1); // Initial width of the image

  const handleZoomIn = () => {

    if (scaleCss < 1.9) {
      setScaleCss(scaleCss + 0.2);
    }
   
  };

  const handleZoomOut = () => {
    if (scaleCss !== 1) {
      setScaleCss(scaleCss - 0.2);
    }
  };
  

  const [territoryBoardData, setTerritoryBoardData] = useState(GameBoardData);

  //#region  Terriotry Linking Data
  const linkingTerritories = {
    1: [2, 3, 32],    // Territory 1 is linked to territories 2 and 3
    2: [1, 3, 4, 12],    // Territory 2 is linked to territories 1 and 4
    3: [1, 2, 4, 6],
    4: [2, 3, 5, 6, 7, 12],
    5: [4, 7, 12],
    6: [3, 4, 7, 8],
    7: [4, 5, 6, 8],
    8: [6, 7, 9, 10],
    9: [8, 10, 11],
    10: [8, 9, 11, 39],
    11: [9, 10],
    12: [2, 4, 5, 13],
    13: [12, 14, 15],
    14: [13, 15, 16, 17],
    15: [13, 14, 16, 19],
    16: [14, 15, 17, 18, 19],
    17: [14, 16, 18, 39],
    18: [16, 17, 19, 22, 39, 40],
    19: [15, 16, 18, 20, 21, 22],
    20: [19, 21, 24, 25],
    21: [19, 20, 22, 23, 24],
    22: [18, 19, 21, 23, 41],
    23: [21, 22, 24, 33],
    24: [20, 21, 23, 25, 27, 33],
    25: [20, 24, 26, 27],
    26: [25, 27, 28],
    27: [24, 25, 26, 28],
    28: [26, 27, 29, 38],
    29: [28, 30, 38],
    30: [29, 31, 32],
    31: [30, 32],
    32: [29, 30, 31, 1],
    33: [23, 24, 34],
    34: [33, 35, 37],
    35: [34, 36, 37],
    36: [35, 37],
    37: [34, 35, 36],
    38: [28, 29],
    39: [10, 17, 18, 40, 41, 42],
    40: [18, 39, 41],
    41: [22, 39, 40, 42, 43, 44],
    42: [39, 41, 43],
    43: [41, 42, 44],
    44: [41, 43],

    // Add more entries for other territories
  };
  //#endregion

  // Target Territories
  const [targetTerritories, setTargetTerritories] = useState([]);

  const handleScreenChange = useContext(ScreenContext);
  const battleScreenRef = useRef(null);

  // Attack Phase Varibales
  let armyCountDeviser = 3;
  const minimumArmyCount = 3;

  const maxAttackerDiceRollCount = 3;
  const maxDefenderDiceRollCount = 3;
  let attackTimeRefill = 7;


  //#endregion

  //#region PlayersData
  const [PlayersData, setPlayersData] = useState([
    {
      playerName: 'Player1',
      playerProfile: '',
      reservedTroopsCount: 0,
      deployedTroopsCount: 0,
      occupiedTerritories: [],
      lastOccupiedTerritory: '',
      defaultTerritory: 0,
      isBotAI: false,
    },
    {
      playerName: 'Player2',
      playerProfile: '',
      reservedTroopsCount: 0,
      deployedTroopsCount: 0,
      occupiedTerritories: [],
      lastOccupiedTerritory: '',
      defaultTerritory: 0,
      isBotAI: true,
    },
    {
      playerName: 'Player3',
      playerProfile: '',
      reservedTroopsCount: 0,
      deployedTroopsCount: 0,
      occupiedTerritories: [],
      lastOccupiedTerritory: '',
      defaultTerritory: 0,
      isBotAI: true
    },
    {
      playerName: 'Player4',
      playerProfile: '',
      reservedTroopsCount: 0,
      deployedTroopsCount: 0,
      occupiedTerritories: [],
      lastOccupiedTerritory: '',
      defaultTerritory: 0,
      isBotAI: true
    },
    {
      playerName: 'Player5',
      playerProfile: '',
      reservedTroopsCount: 0,
      deployedTroopsCount: 0,
      occupiedTerritories: [],
      lastOccupiedTerritory: '',
      defaultTerritory: 0,
      isBotAI: true
    },
    {
      playerName: 'Player6',
      playerProfile: '',
      reservedTroopsCount: 0,
      deployedTroopsCount: 0,
      occupiedTerritories: [],
      lastOccupiedTerritory: '',
      defaultTerritory: 0,
      isBotAI: true
    },
    // Add more player objects as needed
  ]);

  //#endregion

  const [GlobalGameState, setGlobalGameState] = useState('INITIALIZING'); // INITIALIZING || PLAYING || PREPARING || GAMEOVER
  const [GameMode, setGameMode] = useState(''); // QUICK || SINGLE || MULTI
  // State
  const claimPhaseTimer = 10; // In Seconds
  const phaseTimerValue = 30; // In Seconds
  const [playerCount, setPlayerCount] = useState(6); // Total number of players
  const [maxArmyCount, setMaxArmyCount] = useState(40); // // 40 Troops each for 2 Players - (Note: Army is Reduced by 5 for every player count increase down to 20 for 6 Players)
  const [currentTurnPlayer, setCurrentTurnPlayer] = useState(1);
  const [currentPhase, setCurrentPhase] = useState('Reinforcement'); // Reinforcement(Phase to Occupy Empty Terriories or Add more armies to occupied territories)  || Attack (Attack on Enemey Occupied Territories) || Fortify (Move Troops from One territory to other linked territories )
  const [currentGameState, setCurrentGameState] = useState('CLAIM'); // 1. CLAIM 2. DEPLOY 3. COMBAT
  let isDeployStateOver = false;
  const [occupyTroopCount, setoccupyTroopCount] = useState(1); // Set 1 only
  const [phaseTimer, setPhaseTimer] = useState(claimPhaseTimer); // claimPhaseTimer
  const [reinforcementCount, setreinforcementCount] = useState(0);
  const [attackCount, setAttackCount] = useState(10);
  const [fortifyCount, setfortifyCount] = useState(0);
  const [showAttackPopup, setShowAttackPopup] = useState(false);
  const [showReinForcementPopup, setShowReinForcementPopup] = useState(false);
  const [showFortifyPopup, setFortifyPopup] = useState(false);
  const [showBattleScreen, setShowBattleScreen] = useState(false);
  const [showForfietScreen, setShowForfietScreen] = useState(false);
  const [selectedTerritoryIndex, setSelectedTerritoryIndex] = useState(null);
  const [selectedTerritory, setSelectedTerritoryState] = useState(null);
  const [fortifyTargetTerritory, setfortifyrTargetTerritory] = useState(null);
  const [targetTerritory, setTargetTerritory] = useState(null);
  const [possibleTargetTerritoryIndex, setPossibleTargetTerriotryIndex] = useState(null);
  const [targetTerritoryIndex, setTargetTerritoryIndex] = useState(null);
  const [isBattlling, setIsBattling] = useState(false);
  const [isTerritorySelectable, setIsTerritorySelectable] = useState(true);

  // Dice Values
  const [attackerDiceNumber, setAttackerDiceNumber] = useState(0);
  const [defenderDiceNumber, setDefenderDiceNumber] = useState(0);

  // Target Indicator Icon Values
  const [targetImageVisible, setTargetImageVisible] = useState(false);
  const [targetImagePosition, setTargetImagePosition] = useState({ x: 0, y: 0 });

  // Logging Mode 
  const [isLogModeOn, setLogMode] = useState(false);

  // Animations
 // const [animationMessage, setAnimationMessage] = useState('');
 // const [showTimer, setShowTimer] = useState(false);
 // const [animationTimer, setAnimationTimer] = useState(0);
 // const [isAnimating, setIsAnimating] = useState(false);

  // Game State Image
  const [battleResultData, setBattleResultData] = useState(null);
  const [gameStateResult, setGameStateResult] = useState(null);

  // Attack Territorries State 
  const [attackOriginTerritory, setAttackOriginTerritory] = useState(null);
  const [attackTargetTerritory, setAttackTargetTerritory] = useState(null);


  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  //#region  Game Data Initialization

  useEffect(() => {
    setMaxArmyCount(
        playerCount === 2 ? 40 :
        playerCount === 3 ? 35 :
        playerCount === 4 ? 30 :
        playerCount === 5 ? 25 :
        20 // Default value
    );
  }, [playerCount]);

  useEffect(() => {
    const updatedPlayersData = PlayersData.map(player => {
      let updatedPlayer = { ...player };
      updatedPlayer.reservedTroopsCount = maxArmyCount; //Math.min(maxArmyCount, updatedPlayer.reservedTroopsCount);
      return updatedPlayer;
    });
    setPlayersData(updatedPlayersData);
  }, [maxArmyCount]);

  useEffect(() => {

    if (currentGameState === 'CLAIM') {

      setAttackCount(
        //playerCount === 2 ? 40 :
        //playerCount === 3 ? 35 :
        //playerCount === 4 ? 30 :
        //playerCount === 5 ? 25 :
        1 // Default value
      );
    }

  }, [attackCount]);

  useEffect(() => {
    if (currentGameState === 'DEPLOY') {
      console.log('<================== || All Territories have been occupied with troops || Current Game State is Deploy =================>');

    }
  }, [currentGameState]);

  useEffect(() => {

   // console.log('Territory Data has been updated');

  }, [territoryBoardData])

  useEffect(() => {
    checkWinner();

  }, [PlayersData])

  useEffect(() => {

    console.log(`Target territories Updated`);
  }, [targetTerritories])

//#endregion

  const InitializeGameBoard = (gameMode, playerCount) => {

    console.log(`Game Mode ====> ${gameMode} || PlayersCount ====> ${playerCount}`);

    if (gameMode === 'QUICK') {

      for (let i = 0; i < playerCount; i++) {
        // Define newData object with updated reservedTroopsCount
        const newData = {
          isBotAI: true
        };
        // Call updatePlayerData method for the current player index
        updatePlayerData(i, newData);
      }
      
      updateAIActiveStatusExport();
      
    }


    setGameMode(gameMode);
    setPlayerCount(playerCount);

    //startTextAnimation('Game Will Start In ', 5, true, 'PLAYING', gameMode);
    startTextAnimation('Game Will Start In ', 5, true);

    setTimeout(() => {
      console.log(`GameMode ====> ${gameMode} || currentGameState ====> ${currentGameState}`);
      if (gameMode === 'QUICK' && currentGameState === 'CLAIM') {
        console.log(`Current Gameplay Mode is Quick || Executing Player1 Turn`);
        executeBotAIExport(1, true, occupyTroopCount, 0.25, 0.25);
      }
    }, 5000);

  }

  const InitializeCombatState = () => {

    if(GlobalGameState === 'PREPARING'){
      return;
    }

    setGlobalGameState('PREPARING');

    console.log(
      '%c Initialized Combat Game State Called',
      'color: green'
    );


    if (GameMode === 'QUICK') {

      console.log(`Local Player Bot AI property is set back to false`);
      // Define newData object with updated reservedTroopsCount
      const newData = {
        isBotAI: false
      };
      // Call updatePlayerData method for the current player index
      updatePlayerData(0, newData);

    }

    console.log(`Update Reserved Troops has been called`);
    // Loop through each player and set players reserved troops count to 25
    updateReservedTroopsCountForAllPlayers();
   /*  for (let i = 0; i < PlayersData.length; i++) {
       
       const newData = {
         reservedTroopsCount: 25
       };
       
       updatePlayerData(i, newData);
     } */

    console.log('Initialize Combat State Called ');
    setCurrentTurnPlayer(1);
    setPhaseTimer(phaseTimerValue);
    setCurrentGameState('COMBAT');
    //setGlobalGameState('PREPARING');
   // startTextAnimation('Combat Phase Will Start In ', 5, true, 'PLAYING');
    startTextAnimation('Combat Phase Will Start In ', 5, true, 'PLAYING', GameMode);

  }

  const setSelectedTerritory = (territory, deselectLastTerriotry) => {

    if (isLogModeOn) {
      console.log(`Selected territory: ${JSON.stringify(territory)}`);
    }

    if (selectedTerritory !== null && selectedTerritory !== undefined && deselectLastTerriotry) {
      if (isLogModeOn) {
        console.log('Update Selected Territory Called from inside of condiiton');
      }
      updateSelectedTerritoryStatus(selectedTerritory, false);
    }

    if (territory === null || territory === undefined) {
      return;
    }

    setSelectedTerritoryState(territory);
    updateSelectedTerritoryStatus(territory, true);

  };

  //#endregion

  //===============================>
  // Battle Screen
  //===============================>
  const handleStartBattle = () => {

    handleZIndexChangeExport();
    setShowBattleScreen(true);
  };

  const handleCloseBattle = () => {
    setShowBattleScreen(false);
  };

  //===============================>
  // Forfiet Screen
  //===============================>
  const handleOpenForfiet = () => {

    handleForfietZIndexChangeExport();
    setShowForfietScreen(true);
  };

  const handleCloseForfiet = () => {
    setShowForfietScreen(false);
  };

  //===============================================================>
  // Functions to handle Territory Button Click on various phases
  //===============================================================>
  const handleButtonClick = (territory) => {

    console.log(`Is Territory Selectable ====> ${isTerritorySelectable}`);

    if(!isTerritorySelectable){

      console.log(`Is Territory Selectable ====> ${isTerritorySelectable} || Returning Back`);

      return;
    }

    
   // if (isLogModeOn) {
     // console.log(`Handle Button Click || Selected Territory ====> ${JSON.stringify(territory)}`);
   // }

   console.log(`Global ====> ${GlobalGameState} || Current GameState ====> ${currentGameState} || Current Phase ====> ${currentPhase} || Current Player Turn ====> ${currentTurnPlayer} `);

    if(currentTurnPlayer !== 1){
      return;
    }

    if (GlobalGameState === 'INITIALIZING' || GlobalGameState === 'PREPARING') {
      return;
    }

    if ((currentGameState === 'CLAIM' || currentGameState === 'DEPLOY') && GameMode === 'QUICK') {
      return;
    }

    // Perform Attack Action only on Attackable Territory
  /*  if (currentGameState === 'COMBAT' && currentPhase === 'Attack' && selectedTerritory !== null) {

      const linkedTerritories = linkingTerritories[selectedTerritory.id];
      if (!linkedTerritories.includes(territory.id)) {
        return;
      }

    } */

    if ((currentPhase === 'Attack' || currentPhase === 'Fortify') && selectedTerritory === null) {

      if(territory.troopsCount <= 1){
        return;
      }

      if(currentPhase === 'Attack'){
        console.log('Checking if attackable Terrtiories are available');
        const linkedTerritories = linkingTerritories[territory.id];

        let hasEnemyTerritory = false;
        for (const territoryId of linkedTerritories) {
          const territory = territoryBoardData.find(territory => territory.id === territoryId);
          console.log(`Territory Data ====> ${JSON.stringify(territory)}`);
         // console.log(`Territory ====> ${territory.territoryName} || Has Ruler ====> ${territory.territoryRuler}`);
          if (territory && territory.territoryRuler !== 'Player1') {
            hasEnemyTerritory = true;
            break;
          }
        }

        console.log(`Has Enemey Territory ====> ${hasEnemyTerritory}`);
        if(!hasEnemyTerritory){
          console.log(`Has Enemey Territory ====> ${hasEnemyTerritory} || No Enemy Territory Found Roolling back`);
          return;
        }

      }
    }

    // Perform Fortify Action only on Fortifiable Territory
    if ((currentPhase === 'Fortify') && selectedTerritory !== null) {

      if (territory === selectedTerritory) {
        return;
      }

    /*  const linkedTerritories = linkingTerritories[selectedTerritory.id];
      if (!linkedTerritories.includes(territory.id)) {
        if(territory.troopsCount > 1){ //currentPhase === 'Fortify' &&
          console.log('Reinforcement Territory Updated');
          updateSelectedTerritoryStatus(selectedTerritory, false);
          setSelectedTerritoryIndex(territory.id);
          setSelectedTerritory(territory, false);
        }
        return;
      } */

    }

    if(currentPhase === 'Reinforcement'){
      if(PlayersData[currentTurnPlayer - 1].reservedTroopsCount <= 0){
        startTextAnimation('No Troops Left to Reinforce!', 2, false);
        return;
      }
    }


    let currentPlayerName = '';

    //startTextAnimation('Game Will Start In ', 5, true);

    if (currentGameState === 'CLAIM' || currentGameState === 'DEPLOY') {

      if (currentTurnPlayer === 1) {

        if (currentGameState === 'CLAIM') {

          if (territory.territoryRuler === '') {
           // setSelectedTerritoryIndex(territory.id);
            handleOccupitation(territory);
            setSelectedTerritory(territory, true); // Testing Purpose
            moveNextPhase();
            return;
          }

        } else {

          if (territory.territoryRuler === 'Player1') {
            handleOccupitation(territory);
            moveNextPhase();
            return;
          }

        }

      } else {

        return;

      }

      return;

    }

    if (currentPhase === 'Reinforcement') {

      console.log(`Current Phase is Reinfrcement || Clicked Terriotry ${territory.territoryName} || Territory Ruler ====> ${territory.territoryRuler} || Current Player Turn ====> ${currentTurnPlayer}`);

      currentPlayerName = "Player" + currentTurnPlayer;
      if (territory.territoryRuler === currentPlayerName) {

        updateSelectedTerritoryStatus(territory, true);
        setShowReinForcementPopup(true);
        setSelectedTerritory(territory, true);

      } else {

        // showErrorNotification("Current Status is Reinforcement || Can not perform attack on Enemy Occupied or Empty Terriotry || Add Troops to Your Occupied Territory");

      }

    } else if (currentPhase === 'Attack') {

       console.log(`Current Phase is Attack || Clicked Terriotry ${territory.territoryName}`);
      // console.log(`Selected Territory ${JSON.stringify(selectedTerritory)}`);

      currentPlayerName = "Player" + currentTurnPlayer;

      if (selectedTerritory == null) {

        // Initial Territory Selection from where attack has to be performed

        if (territory.territoryRuler === '' || territory.territoryRuler !== currentPlayerName) {

          // showErrorNotification("Current Status is Attack || select Terriotry from where you want to perform attack");

        } else {

          // showErrorNotification("Territory Selected! Now attack on possible attack territories");

          //  setSelectedTerritoryIndex(territory.id);
          // setSelectedTerritory(territory, false);
         // {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Western Europe' && selectedTerritory.territoryRuler === 'Player1' && (

          console.log(`Attack Origin Territory Selected ====> ${territory.territoryName} || Current Phase ===> ${currentPhase} || Selected Territory Ruler ====> ${territory.territoryRuler}`);
          console.log('Reached at Target Code Scope');
          updateSelectedTerritoryStatus(territory, true);
          setSelectedTerritoryIndex(territory.id);
          setSelectedTerritory(territory, true);

          // Add Target Territory Data
          setTargetTerritories(null);
          const linkedTerritoryIds = linkingTerritories[territory.id]; // Retrieve linked territory IDs
          const targetTerritories = linkedTerritoryIds.filter(territoryId => {
              const linkedTerritory = territoryBoardData.find(t => t.id === territoryId);
              return linkedTerritory && linkedTerritory.territoryRuler !== territory.territoryRuler;
          });
          console.log(`Target Territories ====> ${targetTerritories}`);
          setTargetTerritories(targetTerritories);

          return;
        }

      } else {

        if (territory === selectedTerritory) {
          return;
        }

        // Attacking Territory Re Selection
        const linkedTerritories = linkingTerritories[selectedTerritory.id];
      //  if (!linkedTerritories.includes(territory.id)) {
          if(territory.troopsCount > 1 && territory.territoryRuler === 'Player1'){ //currentPhase === 'Fortify' &&
            console.log('Reinforcement Territory Updated');
            updateSelectedTerritoryStatus(selectedTerritory, false);
            setSelectedTerritoryIndex(territory.id);
            setSelectedTerritory(territory, false);

            // Add Target Territory Data
            setTargetTerritories(null);
            const linkedTerritoryIds = linkingTerritories[territory.id]; // Retrieve linked territory IDs
              const targetTerritories = linkedTerritoryIds.filter(territoryId => {
                const linkedTerritory = territoryBoardData.find(t => t.id === territoryId);
                return linkedTerritory && linkedTerritory.territoryRuler !== territory.territoryRuler;
              });
            console.log(`Target Territories ====> ${targetTerritories}`);
            setTargetTerritories(targetTerritories);

            return;

          }

        //  return;
      //  }

        // Section to perform on target territory
        if (territory.territoryRuler === '' || territory.territoryRuler === currentPlayerName) {

          // showErrorNotification("Current Status is Attack || You can only Perfrom Attack action on enemy occupied territory");

        } else {

          const firstSelectedTerritory = selectedTerritory;
          const secondSelectedTerritory = territory;

          setSelectedTerritoryIndex(territory.id);

          //showErrorNotification("Enemy Territory Attacked Successfully!");
          //setShowAttackPopup(true);
          handleAttack(firstSelectedTerritory, secondSelectedTerritory);

          return;
        }

      }

    } else {

      // Fortify Handling State
       console.log(`Current Phase is Fortify || Clicked Terriotry ${territory.territoryName}`);
      // console.log(`Current Phase is Fortify || Selected Terriotry ${JSON.stringify(selectedTerritory)}`);

      currentPlayerName = "Player" + currentTurnPlayer;

      if (selectedTerritory == null) {

        // Initial Territory Selection from where attack has to be performed
        if (territory.territoryRuler === '' || territory.territoryRuler !== currentPlayerName) {

          // showErrorNotification("Current Status is Fortify || select Terriotry from where you want to move troops");

        } else {

          //  showErrorNotification("Territory Selected! Now move troops to possible nearby territories");
          setSelectedTerritoryIndex(territory.id);
          setSelectedTerritory(territory, false);

          return;
        }

      } else {

        // Section to perform on target territory
        if (territory.territoryRuler === '' || territory.territoryRuler !== currentPlayerName) {

          //  showErrorNotification("Current Status is Fortify || You can only move troops between your occupied territory");

        } else {

          setSelectedTerritoryIndex(territory.id);
          setfortifyrTargetTerritory(territory);
          setFortifyPopup(true);

          return;
        }

      }
    }

  };

  //===================================>
  // Function to update Territory data
  //===================================>
  const updateTerritoryData = (id, newData) => {

    // Get the current date and time
    const currentTime = new Date();
    // Format the current time as a string
    const formattedTime = currentTime.toLocaleString(); // Adjust the format as needed
    // Log the message with the current time and data

   // console.log(`[${formattedTime}] New Data ====> ${JSON.stringify(newData)} || at Terrritory Id ====> ${id}`);
    setTerritoryBoardData((prevData) =>
    prevData.map((territory) => (territory.id === id ? { ...territory, ...newData } : territory))
    );

    //console.log(`Updated Troops Count Data ====> ${JSON.stringify(newData)}`);
    if (!isBattleScreenClosedExport && PlayersData[currentTurnPlayer-1].playerName === 'Player1') {
      //console.log(`Updating Attack Troops Count ====> ${newData.troopsCount - 1}`);
      //const updatedAttackCount = newData.troopsCount - 1;
      setAttackCount(1);
    }


   // console.log(` All Territories Data ====> ${JSON.stringify(territoryBoardData)}`);

  };

  //================================>
  // Function to update player data
  //================================>
  const updatePlayerData = (playerIndex, newData) => {
    setPlayersData(prevData => {

      const updatedData = [...prevData];
      updatedData[playerIndex] = { ...updatedData[playerIndex], ...newData };

     // console.log(`Updated Players Data ${JSON.stringify(updatedData)}`);

      // Set Game State from CLAIM to COMBAT

     // console.log(` Current Game State ${currentGameState} || Current Global Game State ${GlobalGameState} `);
      if (currentGameState === 'DEPLOY' && GlobalGameState === 'PLAYING') {

        const allPlayersTroopsCountZero = updatedData.slice(0, playerCount).every(player => player.reservedTroopsCount === 0);
        //console.log(` All Players Count Zero ====> ${allPlayersTroopsCountZero}`);
        if (allPlayersTroopsCountZero) {

          //console.log(' Initialized Combat State Called');
         // InitializeCombatState();

        }
      }

      return updatedData;

    });
  };


  //===============================================================>
  // Function to update player troops count after each turn end
  //===============================================================>
  const updateReservedTroopsCountForAllPlayers = () => {
    //console.log(`Update Players Data Called from Reserved Troops Update`);
    PlayersData.forEach((player, index) => {
      const reservedTroopsCount = Math.max(Math.floor(player.occupiedTerritories.length / 3), 0);
      const updatedPlayerData = { ...player, reservedTroopsCount };
      updatePlayerData(index, updatedPlayerData);
    });
  };

  //================================>
  // Function to change Phase
  //================================>
  const moveNextPhase = () => {

    //  console.log('<========= Move Next Phase has been called =========>');
    let isDeployState = false;
    if (isLogModeOn) {
      console.log('Set Selected Territory Called From here');
    }
    setSelectedTerritory(null, true);

    if (currentGameState === 'CLAIM' || currentGameState === 'DEPLOY') {

      const emptyTerritory = territoryBoardData.find(
        (territory) => territory.troopsCount <= 0
      );
     // console.log(` Deploy State Change || Empty ====> ${JSON.stringify(emptyTerritory)}`);


      if ((emptyTerritory === null || emptyTerritory === undefined) && currentGameState === 'CLAIM') {
        if (isLogModeOn) {
          console.log('<================== || All Territories has been occupied with troops || Current Game State is Deploy =================>');
        }
      //  console.log('<================== || All Territories has been occupied with troops || Current Game State is Deploy =================>');
        setCurrentGameState('DEPLOY');
      //  isDeployState = true;
     //   return;

      }

      const allPlayersTroopsCountZero = PlayersData.slice(0, playerCount).every(player => player.reservedTroopsCount === 0); //updatedData.every(player => player.reservedTroopsCount === 0);

      if ((currentGameState === "CLAIM" || currentGameState === "DEPLOY") && allPlayersTroopsCountZero) {

        console.log('CLAIM || DEPLOY STATE OVER || COMBAT STATE STARTS');
        console.log('Combat Phase Turn Change');
        console.log(' Initialized Combat State Called');
        InitializeCombatState();
        if (isLogModeOn) {
          console.log('CLAIM || DEPLOY STATE OVER || COMBAT STATE STARTS');
          console.log('Combat Phase Turn Change');
        }


      } else if (currentGameState === "COMBAT") {

        changePlayerTurn();
        setPhaseTimer(phaseTimer);

      } else {

        //console.log('CLAIM || DEPLOY Turn Change');
        changePlayerTurn();
        setPhaseTimer(claimPhaseTimer);
      }

      return;
    }

    // Reset Selected Territory of Last Phase
    if(selectedTerritory !== null && selectedTerritory !== undefined){
      updateSelectedTerritoryStatus(selectedTerritory, false);
      setSelectedTerritoryState(null);

      setShowReinForcementPopup(false);
      setShowAttackPopup(false);
      setFortifyPopup(false);
      
    }
   
    setreinforcementCount(0);
    setAttackCount(0);
    setfortifyCount(0);

    switch (currentPhase) {

      case 'Reinforcement':
        setCurrentPhase('Attack');
        break;
      case 'Attack':
        setCurrentPhase('Fortify');
        break;
      case 'Fortify':
        setCurrentPhase('Reinforcement');
        changePlayerTurn();
        return;
        break;
      default:
        setCurrentPhase('Reinforcement');
        break;
    }


    console.log(`Current Phase ====> ${currentPhase} || Player Turn Not Changed`);
    setPhaseTimer(phaseTimerValue);

    if (PlayersData[currentTurnPlayer - 1].isBotAI) {

      console.log(`Current Player Turn ====> ${currentTurnPlayer - 1}`);
      if (currentGameState === "COMBAT" && (currentTurnPlayer - 1) === 0) {
        return;
      }
      //aiController.executeBotAI(currentTurnPlayer - 1, false, occupyTroopCount);
      console.log(`Bot AI Index =====> ${currentTurnPlayer - 1}`);
      executeBotAIExport(currentTurnPlayer - 1, false, occupyTroopCount);

    }

  };

  //================================>
  //Function to change player turn
  //================================>
  const changePlayerTurn = () => {

    // Set Phase Timer On Player Turn Change at starting
    setPhaseTimer(phaseTimerValue);

    if (GlobalGameState === 'GAMEOVER') {
      return;
    }

    if (currentGameState === 'COMBAT') {
      console.log(`Update Player Data Called`);
      updateReservedTroopsCountForAllPlayers();
    }

    setCurrentTurnPlayer((prevPlayer) => (prevPlayer % playerCount) + 1);

    const nextPlayer = (currentTurnPlayer % playerCount) + 1;
    const playerList = [...PlayersData];

    if (playerList[nextPlayer - 1].isBotAI) {

      if (currentGameState === 'CLAIM' || currentGameState === 'DEPLOY') {
        if (GameMode === 'QUICK') {
          executeBotAIExport(nextPlayer - 1, true, occupyTroopCount, 0.25, 0.25);
        } else {
          executeBotAIExport(nextPlayer - 1, true, occupyTroopCount, 0.25, 0.25);
        }
      } else {
        executeBotAIExport(nextPlayer - 1, false, occupyTroopCount);
      }
    }
  };

  //====================================>
  //Manually Btn click to change phase
  //====================================>
  const handleMovePhaseClick = () => {

    if(currentPhase === 'Attack' && selectedTerritory !== null){
     
      console.log(` Retruning From Move Attack Phase || Selected Territory Datav ====> ${JSON.stringify(selectedTerritory)}`);
      return;
      
    }

    if(currentGameState !== "COMBAT"){
      return;
    }

    if (currentTurnPlayer != 1) {
      return;
    }

    moveNextPhase();

  };

  //====================================>
  //Function to handle Occupitation
  //====================================>
  const handleOccupitation = (territory) => {

    const previousCounter = territory.troopsCount || 0;
    const newTroopCount = previousCounter + occupyTroopCount;

    updateTerritoryData((territory.id), {
      territoryRuler: `Player${currentTurnPlayer}`,
      troopsCount: newTroopCount,
      lastTroopsCount: previousCounter,
    });

    mobilizePlayerTroops(false, attackCount, territory);

  }

  //====================================>
  //Function to handle Reinforcement
  //====================================>
  const handleReinforcement = () => {

    const territory = selectedTerritory;

    if (territory.territoryRuler === '') {

      if (isLogModeOn) {
        console.log('Manual Player Reinforcment If Part');
      }

      updateTerritoryData(territory.id, {
        territoryRuler: `Player${currentTurnPlayer}`,
        troopsCount: reinforcementCount,
      });

    } else {

      if (isLogModeOn) {
        console.log('Manual Player Reinforcment Else Part');
      }

      const previousCounter = territory.troopsCount || 0;
      const updatedTroopsCount = previousCounter + reinforcementCount;
      updateTerritoryData(territory.id, {
        territoryRuler: `Player${currentTurnPlayer}`,
        troopsCount: updatedTroopsCount,
      });
    }

    mobilizePlayerTroops(false, reinforcementCount, territory);
    setShowReinForcementPopup(false);
    setSelectedTerritory(null, true);
    setSelectedTerritoryState(null);
    setreinforcementCount(0);
   // moveNextPhase();

  };

  //====================================>
  //Function to handle Attack Phase
  //====================================>
  const handleAttack = async (firstSelectedTerritory, secondSelectedTerritory) => {

    setIsTerritorySelectable(false);

    updateTerritoryData(secondSelectedTerritory.id, {
      isTagetTerritory: true
    }); 

    setTimeout(() => {
      updateTerritoryData(secondSelectedTerritory.id, {
        isTagetTerritory: false
      }); 
    }, 2000);

    await new Promise(resolve => setTimeout(resolve, 2000));


    //  console.log('Initiating attack...');
    if (isLogModeOn) {
      console.log(`Handle Attack Logic`);
    }

    const territory = secondSelectedTerritory; //territoryBoardData[selectedTerritoryIndex];
    // updateTerritoryData((territory.id), {
    // isTagetTerritory: true,
    // });

    const previousCounter = territory.troopsCount || 0;
    // const attackerDiceNum = rollDice();
    // const defenderDiceNum = rollDice();

    // setAttackerDiceNumber(attackerDiceNum);
    // setDefenderDiceNumber(defenderDiceNum);
    //updateDiceValues(attackerDiceNum, defenderDiceNum);


    await new Promise(resolve => setTimeout(resolve, 1000));
   // setTimeout(() => {

      setIsBattling(true);
      //console.log(`Attacker Dice Number ====> ${attackerDiceNumber} || Defender Dice Number ====>  ${defenderDiceNumber}`);
      setAttackOriginTerritory(firstSelectedTerritory);
      setAttackTargetTerritory(secondSelectedTerritory);
      await initializeBattleScreenDataExport(firstSelectedTerritory, secondSelectedTerritory, playerProfile, player2Profile);
      handleZIndexChangeExport(false);

   // }, 1000);

    //await delay(2500);

    if (!isBattleScreenClosedExport) {

      while (!isBattleScreenClosedExport) {
        // Wait for 500 milliseconds before checking again
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }

    console.log(`Battle Screen Result ====> ${JSON.stringify(BattleDataExport)}`);

    let hasWonBattle = false;
    if (BattleDataExport.BattleStatus.winnerPlayer === 'Player1') {
      console.log(`Attack has been won by player 1`);
      hasWonBattle = true;

     // updateAttackCount(firstSelectedTerritory);
      // Update Attackable Troops Count
     /* const territory = territoryBoardData.find(territory => territory.id === firstSelectedTerritory.id);

      // Get the current date and time
      const currentTime = new Date();
      // Format the current time as a string
      const formattedTime = currentTime.toLocaleString(); // Adjust the format as needed
      // Log the message with the current time
      console.log(`[${formattedTime}] Attacking Troops count has been updated for territory ====> ${territory.territoryName} || Troops Count ====> ${territory.troopsCount - 1} || Territory Data ====> ${JSON.stringify(territory)}`);

      setAttackCount(territory.troopsCount - 1);  */
    } else {
      console.log(`Attack has been lost by player 1`);
      hasWonBattle = false;
    }

    setIsBattling(false);
    setIsTerritorySelectable(true);
    if (!hasWonBattle) {
      startTextAnimation('You have Lost Attack! ', 2, false);
      setSelectedTerritoryIndex(0);
      updateSelectedTerritoryStatus(firstSelectedTerritory, false);
      setSelectedTerritory(firstSelectedTerritory, false);
      setSelectedTerritoryState(null);
      moveNextPhase();
      return
    }
    //return;

    //console.log('BattleScreen is closed. Proceeding with attack logic...');
    //console.log(`Attacker Dice Number ====> ${attackerDiceNum} || Defender Dice Number ====>  ${defenderDiceNum}`);

    const territoryAttacker = territoryBoardData.find(territory => territory.id === firstSelectedTerritory.id);

    if( territoryAttacker.troopsCount <= 2){

      setAttackCount(1);

      // Update Attack Target Territory
     /* updateTerritoryData((territoryAttacker.id), {
        territoryRuler: `Player${currentTurnPlayer}`,
        troopsCount: 1,
      });

      // Update Attack Origin Territory
      updateTerritoryData((secondSelectedTerritory.id), {
        troopsCount: 1,
      }); */

      perfromAttackWon(secondSelectedTerritory, firstSelectedTerritory);

      return;

    }

    setShowAttackPopup(true);


    /* if (attackerDiceNum > defenderDiceNum) {
 
       updateTerritoryData((territory.id), {
         territoryRuler: `Player${currentTurnPlayer}`,
         troopsCount: attackCount,
       });
 
       mobilizePlayerTroops(false, attackCount, territory);
       showErrorNotification("Attack Successfull. Occupied Enemy Territory.");
       moveNextPhase();
 
     } else {
       showErrorNotification("Attack failed. There are excessive defending troops.");
       if (isLogModeOn) {
         console.log('Attack failed. Counter requirement not met.');
       }
     }
 
     //updateTerritoryData((territory.id), {
     //  isTagetTerritory: false,
     // });
 
     if (isLogModeOn) {
       console.log(`%cHandle Attack Logic || Selected Territory ====> ${JSON.stringify(territory)}`, 'color: blue');
     }
 
     setShowAttackPopup(false);
     updateSelectedTerritoryStatus(firstSelectedTerritory, false);
     updateSelectedTerritoryStatus(secondSelectedTerritory, false);
     setSelectedTerritoryState(null);
 
 
     let updatedPhaseTimer = phaseTimer + attackTimeRefill;
     setPhaseTimer(updatedPhaseTimer); */

  };

  //Dummy Attack Count Fucntion

  function updateAttackCount(originTerritory){

    console.log(` All Territories Data ====> ${JSON.stringify(territoryBoardData)}`);

     // Update Attackable Troops Count
     const territory = territoryBoardData.find(territory => territory.id === originTerritory.id);

     // Get the current date and time
     const currentTime = new Date();
     // Format the current time as a string
     const formattedTime = currentTime.toLocaleString(); // Adjust the format as needed
     // Log the message with the current time
     //console.log(`[${formattedTime}] Attacking Troops count has been updated for territory ====> ${territory.territoryName} || Troops Count ====> ${territory.troopsCount - 1} || Territory Data ====> ${JSON.stringify(territory)}`);

     setAttackCount(territory.troopsCount - 1); 

  }
  // Dummy

  function rollDice() {
    // Generate a random number between 1 and 6
    return Math.floor(Math.random() * 6) + 1;
  }
  //====================================>
  // Function to modify dice values
  //====================================>
  const updateDiceValues = (attackerDiceValue, defenderDiceValue) => {
    // Check if the ref has been initialized
    if (battleScreenRef.current) {
      // Call the update functions of the BattleScreen component using the ref
      battleScreenRef.current.updateAttackerDiceValue(attackerDiceValue);
      battleScreenRef.current.updatedefenderDiceValue(defenderDiceValue);
    }
  };

  //====================================>
  //Function to handle Fortify Phase
  //====================================>
  const handleFortify = () => {

    if (isLogModeOn) {
      console.log(`Handle Fortify Logic`);
    }

    const territory = fortifyTargetTerritory;
    const previousCounter = territory.troopsCount || 0;
    const updatedTroopsCount = previousCounter + fortifyCount;

    let fortifyOriginTroopCount = selectedTerritory.troopsCount || 0;
    fortifyOriginTroopCount -= fortifyCount;

    updateTerritoryData(territory.id, {
      troopsCount: updatedTroopsCount,
    });

    updateTerritoryData(selectedTerritory.id, {
      troopsCount: fortifyOriginTroopCount,
    });

    setFortifyPopup(false);
    setSelectedTerritory(selectedTerritory, true);
    setSelectedTerritoryState(null);
    setfortifyCount(0);

    updateSelectedTerritoryStatus(selectedTerritory, false);

    moveNextPhase();

  };

  //====================================>
  //Function to Mobilize Troops
  //====================================>
  const mobilizePlayerTroops = (isAiModilization, mobilizedTroopsCount, territory) => {

      console.log(`%c Mobilize Players Called || `, 'color: purple');

    if (isAiModilization) {

    } else {

      const playerList = [...PlayersData];

      if (!playerList[currentTurnPlayer - 1].occupiedTerritories.includes(territory.id)) {
        playerList[currentTurnPlayer - 1].occupiedTerritories.push(territory.id);
      }
      //playerList[currentTurnPlayer - 1].occupiedTerritories.push(selectedTerritoryIndex);
      playerList[currentTurnPlayer - 1].lastOccupiedTerritory = territory.id;
      playerList[currentTurnPlayer - 1].reservedTroopsCount -= mobilizedTroopsCount;
      playerList[currentTurnPlayer - 1].deployedTroopsCount += mobilizedTroopsCount;

      updatePlayerData(currentTurnPlayer - 1, playerList[currentTurnPlayer - 1]);
      removeTerritoryFromOtherPlayers((currentTurnPlayerExport - 1), territory.id);

    }
  }

  //===============================================>
  // Function to terriotry from other Players data
  //===============================================>

  const removeTerritoryFromOtherPlayers = (playerIndex, territoryId) => {
    if (isLogModeOn) {
      console.log(`Player ${playerIndex} Occupied Territory ${territoryId} `);
    }

    const updatedPlayersData = PlayersData.map((player, index) => {
      if (index !== playerIndex) {
        const updatedOccupiedTerritories = [...player.occupiedTerritories];
        const indexOfTerritory = updatedOccupiedTerritories.indexOf(territoryId);
        if (indexOfTerritory !== -1) {
          updatedOccupiedTerritories.splice(indexOfTerritory, 1);
        }
        return { ...player, occupiedTerritories: updatedOccupiedTerritories };
      }
      return player;
    });

    // Update the playersData state with the updatedPlayersData
    setPlayersData(updatedPlayersData);
  };

  const updateSelectedTerritoryStatus = (territory, isSelected) => {

    if (isLogModeOn) {
      console.log(`Territory ====> ${JSON.stringify(territory)} || Is Selected Value ====> ${isSelected}`);
    }

    if(territory === null || territory === undefined){
      return;
    }

    updateTerritoryData((territory.id), {
      isSelectedTerritory: isSelected,
    });

    /* if(isSelected){
       const targetTerritoryPosition = { x: territory.x, y: territory.y };
       console.log(`Target Territory Position ${targetTerritoryPosition}`);
       showTargetImage(targetTerritoryPosition);
 
     }; */

  }

  //==============================>
  // Troops Selection Handling
  //==============================>
  const handleTroopsCountDecrease = () => {
    console.log('Decrease');
    updatetPlayersCount(false);
  };

  const handleTroopsCountIncrease = () => {
    console.log('Increase');
    updatetPlayersCount(true);
  };

  const updatetPlayersCount = (isIncrease) => {

    console.log('Selected Troops Count Value Changed');
    let minValue = 0;
    let maxValue = 0;

    if (currentPhase === 'Reinforcement') {

      // Define your range here (for example, between 0 and 10)
     // console.log(` Reinforcement Phase || Current Player Reserved Troops Count ====> ${PlayersData[currentTurnPlayer].reservedTroopsCount}`);
      minValue = 1;
      maxValue = PlayersData[currentTurnPlayer - 1].reservedTroopsCount;
      // Ensure the value is within the specified range

      // Update the state with the modified value
      // setreinforcementCount(value);

      if (isIncrease) {
        if (reinforcementCount === maxValue) {
          setreinforcementCount(minValue);
        } else {
          setreinforcementCount(reinforcementCount + 1);
        }

      } else {

        if (reinforcementCount === minValue || reinforcementCount < minValue) {
          setreinforcementCount(maxValue);
        } else {
          setreinforcementCount(reinforcementCount - 1);
        }
      }


      return;

    }

    if (currentPhase === 'Attack') {


      console.log(`Attack Origin Territory Data =====> ${JSON.stringify(attackOriginTerritory)}`)
      // Define your range here (for example, between 0 and 10)

      const territory = territoryBoardData.find(territory => territory.id === attackOriginTerritory.id);
      minValue = 1;
      maxValue = territory.troopsCount - 1;
      // Ensure the value is within the specified range

      if (isIncrease) {

        if (attackCount === maxValue) {
          setAttackCount(minValue);
        } else {
          setAttackCount(attackCount + 1);
        }

      } else {

        if (attackCount === minValue || attackCount < minValue) {
          setAttackCount(maxValue);
        } else {
          setAttackCount(attackCount - 1);
        }
      }

      return;
    }

    if (currentPhase === 'Fortify') {

      // Define your range here (for example, between 0 and 10)
      minValue = 1;
      maxValue = selectedTerritory.troopsCount - 1;
      // Ensure the value is within the specified range

      if (isIncrease) {

        if (fortifyCount === maxValue) {
          setfortifyCount(minValue);
        } else {
          setfortifyCount(fortifyCount + 1);
        }

      } else {

        if (fortifyCount === minValue || fortifyCount < minValue) {
          setfortifyCount(maxValue);
        } else {
          setfortifyCount(fortifyCount - 1);
        }
      }

      return;
    }
  }

  //==========================>
  // Perform Action handling
  //==========================>
  const handleAction = () => {

    if (currentPhase === 'Reinforcement') {

      console.log(`Current Phase Reinforcement || Performing Reinforcement with Troops Count ====> ${reinforcementCount}`);
      handleReinforcement();

    } else if (currentPhase === 'Attack') {

      console.log(`Current Phase Attack || Performing Attack with Troops Count ====> ${attackCount}`);
      perfromAttackWon(null, null);

    } else if (currentPhase === 'Fortify') {

      console.log(`Current Phase Fortify || Performing Fortification with Troops Count ====> ${fortifyCount}`);
      handleFortify();
    }

  }

  //===============================>
  // Perform Action Reset Handling
  //===============================>
  const handleResetAction = () => {

    console.log('Action Reset');

    if (currentPhase === 'Reinforcement' || currentPhase === 'Fortify') {

      console.log(`Selection Restted in Phase =====> ${currentPhase}`);
      
      updateSelectedTerritoryStatus(selectedTerritory, false);
      setSelectedTerritoryState(null);
      setShowReinForcementPopup(false);
      setFortifyPopup(false);
      //setSelectedTerritory(null, true);


    } else if (currentPhase === 'Attack') {

      //console.log(`Current Phase Attack || Performing Attack with Troops Count ====> ${attackCount}`);
      //perfromAttackWon();

    }

  }

  //===============================>
  // Handle Forfiet
  //===============================>
  const handleForfiet = () => {

    handleForfietZIndexChangeExport();
    
  }

  //===============================>
  // Handle Forfiet
  //===============================>
  const handleSetting = () => {

    handleSettingZIndexChangeExport();
    
  }

  //===============================>
  // Perform ForFiet Action
  //===============================>
  const handeForfietAcion = () => {

  }
  //=================================>
  // Fucntion to Perfrom Attack Won 
  //=================================>

  const perfromAttackWon = (localAttackTargetTerritory, localAttackOriginTerritory) => {



    if(localAttackTargetTerritory != null && localAttackTargetTerritory !== undefined){

      updateTerritoryData((localAttackTargetTerritory.id), {
        territoryRuler: `Player${currentTurnPlayer}`,
        troopsCount: 1,
      });

      updateTerritoryData((localAttackOriginTerritory.id), {
        troopsCount: 1,
      });

      updateSelectedTerritoryStatus(localAttackOriginTerritory, false);
      updateSelectedTerritoryStatus(localAttackTargetTerritory, false);
      setSelectedTerritoryState(null);
      setAttackCount(0);


    }else{

      console.log(`Attacking Target Territory Data ====> ${JSON.stringify(attackTargetTerritory)}`);
      // Update Attack Target Territory
      updateTerritoryData((attackTargetTerritory.id), {
        territoryRuler: `Player${currentTurnPlayer}`,
        troopsCount: attackCount,
      });

       // Update Attack Origin Territory
        console.log(`Attacking Origin Territory Data ====> ${JSON.stringify(attackOriginTerritory)}`);
       const territory = territoryBoardData.find(territory => territory.id === attackOriginTerritory.id);
      updateTerritoryData((attackOriginTerritory.id), {
        troopsCount: territory.troopsCount - attackCount,
      });

    }

    const playerList = [...PlayersData];

    if (!playerList[currentTurnPlayer - 1].occupiedTerritories.includes(selectedTerritoryIndex)) {
      playerList[currentTurnPlayer - 1].occupiedTerritories.push(selectedTerritoryIndex);
    }

    //playerList[currentTurnPlayer - 1].occupiedTerritories.push(selectedTerritoryIndex);
    playerList[currentTurnPlayer - 1].lastOccupiedTerritory = selectedTerritoryIndex;

    updatePlayerData(currentTurnPlayer - 1, playerList[currentTurnPlayer - 1]);
    removeTerritoryFromOtherPlayers((currentTurnPlayerExport - 1), selectedTerritoryIndex);

    //mobilizePlayerTroops(false, attackCount, attackTargetTerritory);

    setShowAttackPopup(false);
    updateSelectedTerritoryStatus(attackOriginTerritory, false);
    updateSelectedTerritoryStatus(attackTargetTerritory, false);
    setSelectedTerritoryState(null);
    setAttackCount(0);

   // setTimeout(() => {

    //  moveNextPhase();

   // }, 2000);

    //updateTerritoryData((territory.id), {
    //  isTagetTerritory: false,
    // });

    if (isLogModeOn) {
      console.log(`%cHandle Attack Logic || Selected Territory ====> ${JSON.stringify(attackTargetTerritory)}`, 'color: blue');
    }

    let updatedPhaseTimer = phaseTimer + attackTimeRefill;
    setPhaseTimer(updatedPhaseTimer); 

  }

  //#region Game State Track

  //===========================>
  // Function to Track Winner
  //===========================>
  const checkWinner = () => {

    const allTerritoriesHaveSameRuler = isSameRulerForAllTerritories();
    if (allTerritoriesHaveSameRuler) {
     // console.log("All territories have the same ruler || Winner Declare State");
      declareWinnerPlayer(territoryBoardData[0].territoryRuler);
    } else {
    //  console.log("Territories have different rulers || Gameplay Continues");
    }

  };

  //==========================================================================>
  // Function to Track if all territories has been occupied by single player
  //==========================================================================>
  const isSameRulerForAllTerritories = () => {

    if (territoryBoardData.length === 0) {
      return false;
    }

    const firstRuler = territoryBoardData[0].territoryRuler;

    if (firstRuler === '') {
      return;
    }

    for (let i = 1; i < territoryBoardData.length; i++) {
      if (territoryBoardData[i].territoryRuler !== firstRuler) {
        return false;
      }
    }
    return true;

  };

  //===============================>
  // Function to Declare Winner
  //===============================
  const declareWinnerPlayer = (winnerPlayer) => {


    if (winnerPlayer === 'Player1') {
      console.log('Local Player Won');
      setGameStateResult(victoryScreen);
    } else {
      console.log(`AI Player won || AI Player ====> ${winnerPlayer}`);
      setGameStateResult(defeatScreen);
    }
    setGlobalGameState('GAMEOVER');

  }

  //#endregion


  const restoreAttackTimer = () => {

    let updatedPhaseTimer = phaseTimer + attackTimeRefill;
    setPhaseTimer(updatedPhaseTimer);

  }
  //================================================================>
  // Function to make the target image visible and set its position
  //================================================================>
  const showTargetImage = (position) => {

    setTargetImagePosition(position);
    setTargetImageVisible(true);
  };

  //=============================================>
  // Function to show Error Status Notification
  //=============================================>
  const showErrorNotification = (messageTxt) => {
    window.alert(messageTxt);
  };

  //=============================================>
  // Text Animation
  //=============================================>
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationMessage, setAnimationMessage] = useState('');
  const [animationDuration, setAnimationDuration] = useState(0);

  const startTextAnimation = (text, duration, showTimer) => {
    if(showTimer){
      setAnimationMessage(`${text} ${duration}`);
    }else{
      setAnimationMessage(`${text}`);
    }
   
    setAnimationDuration(duration);
    setIsAnimating(true);

    if (showTimer) {
      let timer = duration;

      const timerInterval = setInterval(() => {
        timer--;

        if(showTimer){
          setAnimationMessage(`${text} ${timer}`);
        }else{
          setAnimationMessage(`${text}`);
        }
        
        if (timer === 0){
          
          clearInterval(timerInterval);
        } 
      }, 1000);
    }
  };


  useEffect(() => {
    if (isAnimating) {
      const animationTimer = setTimeout(() => {
        setIsAnimating(false);
        setAnimationMessage('');
        setAnimationDuration(0);
        setGlobalGameState('PLAYING');
      }, (animationDuration) * 1000);

      return () => clearTimeout(animationTimer);
    }
  }, [isAnimating, animationDuration]);
  
  //=================>
  // Timer effect
  //=================>
  useEffect(() => {

    if (GlobalGameState === 'PLAYING' && !isBattlling) {
      const timer = setTimeout(() => {
        setPhaseTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      if (phaseTimer <= 0) {
        setPhaseTimer(currentGameState !== 'COMBAT' ? claimPhaseTimer : phaseTimerValue);
        moveNextPhase();
      }

      return () => clearTimeout(timer);
    }

  }, [phaseTimer, GlobalGameState]);

  //=================>
  // Exports
  //=================>

  PlayersDataExport = PlayersData;
  currentPhaseExport = currentPhase;

  territoryBoardDataExport = territoryBoardData;
  linkingTerritoriesExport = linkingTerritories;
  currentTurnPlayerExport = currentTurnPlayer;

  updateTerritoryDataExport = updateTerritoryData;
  updatePlayerDataExport = updatePlayerData;

  movePhaseExport = moveNextPhase;
  setCurrentGameStateExport = setCurrentGameState;

  rollDiceExport = rollDice;
  attackerDiceNumberExport = attackerDiceNumber;
  defenderDiceNumberExport = defenderDiceNumber;
  setAttackerDiceNumberExport = setAttackerDiceNumber;
  setDefenderDiceNumberExport = setDefenderDiceNumber;

  removeTerritoryFromOtherPlayersExport = removeTerritoryFromOtherPlayers;
  isLogModeOnExport = isLogModeOn;

  InitializeGameBoardExport = InitializeGameBoard;

  battleResultDataExport = battleResultData;
  SetBattleResultDataExport = setBattleResultData;

  restoreAttackTimerExport = restoreAttackTimer;
  phaseTimerExport = phaseTimer;

  // Player Profile
  playerProfile1 = playerProfile;
  playerProfile2 = player2Profile;
  playerProfile3 = player3Profile;

   // Create a ref to store references to territory elements
   const territoryRefs = useRef({});

   // Function to store the reference of territory elements
  const saveTerritoryRef = (id, ref) => {
    territoryRefs.current[id] = ref;
  };

   // Create refs for the arrow elements
   const arrow1Ref = useRef(null);
   const arrow2Ref = useRef(null);


  // JSX
  return (


    <div className="image-container" style={{ position: 'relative', width: '100%', height: 'auto'}}>

<div>
        
        {<SettingScreen />}
      </div>

      {/* Map Image */}
      {/* Map Image */}
      <div style={{ transform: `scale(${scaleCss})` }}>
        <img
          id="main-img"
          src={require("./Assets/Images/GameBoard/PlayScreen.png")}
          alt="Map"
          style={{
            width: "100%",
            height: "100vh",
          }}
        />

      {((showReinForcementPopup || showAttackPopup || showFortifyPopup) &&
        <img src={overlayImage} alt="Overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: 'auto', zIndex: 99 }} />
      )}

      {((GlobalGameState === 'GAMEOVER') &&
        <img src={gameStateResult} alt="gameStatePanel" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 101 }} />
      )}

      {/* Territory Buttons */}
      <div>
      {territoryBoardData.map((territory) => {
        let imageIndex;
        let territoryName;

        // console.log(territory.territoryName === 'Alaska');
        if (territory.territoryName !== 'Territory38') {

          //console.log("Inside Territory name equals to Alaska")

          if (territory.territoryRuler === 'Player1') {
            imageIndex = 1;
            // console.log("Inside Territory ruler is Player1")
          } else if (territory.territoryRuler === 'Player2') {
            // console.log("Inside Territory ruler is Player2")
            imageIndex = 2;
          } else if (territory.territoryRuler === 'Player3') {
            // console.log("Inside Territory ruler is Player3")
            imageIndex = 3;
          } else if (territory.territoryRuler === 'Player4') {
            // console.log("Inside Territory ruler is Player4")
            imageIndex = 4;
          } else if (territory.territoryRuler === 'Player5') {
            // console.log("Inside Territory ruler is Player4")
            imageIndex = 5;
          } else if (territory.territoryRuler === 'Player6') {
            // console.log("Inside Territory ruler is Player4")
            imageIndex = 6;
          } else {
            // console.log("Inside Territory ruler is null")
            imageIndex = 0;
          }
          territoryName = territory.territoryName;

          // imageIndex = 1;

        } else {
          territoryName = undefined;
          imageIndex = undefined;
        }


         {/*transform: `scale(${scaleCss})`*/}
        return (
          <TerritoryButton
            key={territory.id}
            territoryId ={territory.id}
            territoryRuler={territory.territoryRuler}
            territoryName={territoryName.replace(/\s+/g, '')}
            imageIndex={imageIndex}
            gamePhase={currentPhase}
            isSelectedTerritory={territory.isSelectedTerritory}
            isTagetTerritory={territory.isTagetTerritory}
            
            style={{ position: 'absolute', top: `${territory.y}%`, left: `${territory.x}%` }}// left: `${territory.x}%`,}} // , top: `${territory.y}%`, left: `${territory.x}%`, }}
            topPos = {territory.y}//`${territory.y}%`}
            overlayStyle={territory.overlayStyle}
            targetIconStyle = {territory.targetIconStyle}
            territoryWidth={territory.territoryWidth}
            territoryHeight={territory.territoryHeight}
            // styleTerritoryHolder ={{ position: 'absolute', top: `${territory.territoryHolder.y}%`, left: `${territory.territoryHolder.x}%` }}
            styleTerritoryHolderX={territory.territoryHolder.x}
            styleTerritoryHolderY={territory.territoryHolder.y}
            styleTerritoryHolderHeight={territory.territoryHolder.height}
            styleTerritoryHolderWidth={territory.territoryHolder.width}
            troopCount={territory.troopsCount}
            addedTroopsCount={territory.troopsCount - territory.lastTroopsCount}
            onAttackClick={() => handleButtonClick(territory)}
            className={`territory-${territory.id}`} // Define class name using territory ID
            ref={(ref) => saveTerritoryRef(territory.id, ref)} // Save reference to territory element
          />
        );

      })}
      </div>

      {/* Target Arrows Section */}

      {/* Arrow Indicator*/}
      {/* Alaska Terriotory*/}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Alaska' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
      
          {targetTerritories.includes(2) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '22.5%', left: '15.5%', zIndex: 3, width: '5%', height: '8%', transform: `rotate(${30}deg)` }} />
          )}
           {targetTerritories.includes(3) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: '15.7%', zIndex: 3, width: '5%', height: '8%', transform: `rotate(${60}deg)` }} />
           )}

          {targetTerritories.includes(32) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '25%', left: "-21%", zIndex: 3, width: '40%', height: '5%', transform: `rotate(${185}deg)` }} />
          )}

          {targetTerritories.includes(32) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23%', right: "-5%", zIndex: 3, width: '23%', height: '5%', transform: `rotate(${190}deg)` }} />
          )}
          
        </>
      )}

       {/* North West Terriotory*/}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'North West Territory' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
        {targetTerritories.includes(1) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23%', left: '15%', zIndex: 3, width: '8%', height: '6%', transform: `rotate(${210}deg)` }} />
        )}
         {targetTerritories.includes(3) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '27%', left: '19%', zIndex: 3, width: '5%', height: '5%', transform: `rotate(${130}deg)` }} />
         )}
         {targetTerritories.includes(4) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: '21.5%', zIndex: 3, width: '7%', height: '6%', transform: `rotate(${60}deg)` }} />
         )}
         {targetTerritories.includes(12) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '19%', left: '20%', zIndex: 3, width: '20%', height: '8%', transform: `rotate(${0}deg)` }} />
         )}
          </>
      )}

      {/* Alberta*/}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Alberta' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          {targetTerritories.includes(1) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28%', left: "17%", zIndex: 3, width: '6%', height: '6%', transform: `rotate(${230}deg)` }} />
          )}
          {targetTerritories.includes(2) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26.5%', left: '19%', zIndex: 3, width: '5%', height: '5%', transform: `rotate(${-80}deg)` }} />
          )}
          {targetTerritories.includes(4) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '30.5%', left: '22.5%', zIndex: 3, width: '6%', height: '6%', transform: `rotate(${45}deg)` }} />
          )}
          {targetTerritories.includes(6) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '33.5%', left: '20.5%', zIndex: 3, width: '6%', height: '6%', transform: `rotate(${90}deg)` }} />
          )}

        </>
      )}


      {/* Ontario*/}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Ontario' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
         {targetTerritories.includes(2) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28%', left: '24%', zIndex: 3, width: '5%', height: '5%', transform: `rotate(${-120}deg)` }} />
        )}
        {targetTerritories.includes(3) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '30.5%', left: '23%', zIndex: 3, width: '6%', height: '6%', transform: `rotate(${200}deg)` }} />
        )}
        {targetTerritories.includes(6) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '33%', left: '24%', zIndex: 3, width: '6%', height: '6%', transform: `rotate(${160}deg)` }} />
        )}
        {targetTerritories.includes(7) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '34.5%', left: '26.5%', zIndex: 3, width: '6%', height: '6%', transform: `rotate(${100}deg)` }} />
        )}
         {targetTerritories.includes(12) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '24%', left: '26.5%', zIndex: 3, width: '15%', height: '8%', transform: `rotate(${-10}deg)` }} />
         )}
        </>
      )}

      {/* Quebec */}
      { selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Quebec' && selectedTerritory.territoryRuler === 'Player1'  && (
        <>
        {targetTerritories.includes(4) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '30%', left: '27%', zIndex: 3, width: '7.5%', height: '5%', transform: `rotate(${-150}deg)` }} />
        )}
        {targetTerritories.includes(7) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '34%', left: '28.5%', zIndex: 3, width: '7%', height: '6%', transform: `rotate(${160}deg)` }} />
        )}
        {targetTerritories.includes(12) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '25%', left: '31.25%', zIndex: 3, width: '12%', height: '6%', transform: `rotate(${-30}deg)` }} />
        )}
        </>
      )}


      {/* Western United States */}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Western UnitedStates' && selectedTerritory.territoryRuler === 'Player1'&& (
        <>
      
        {targetTerritories.includes(3) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36%', left: '22%', zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${-80}deg)` }} />
        )}
        {targetTerritories.includes(4) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36%', left: '24.2%', zIndex: 3, width: '4.5%', height: 'auto', transform: `rotate(${-10}deg)` }} />
        )}

        {targetTerritories.includes(7) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '41%', left: '24.5%', zIndex: 3, width: '4.5%', height: 'auto', transform: `rotate(${70}deg)` }} />
        )}

        {targetTerritories.includes(8) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '42%', left: '22.5%', zIndex: 3, width: '4.2%', height: 'auto', transform: `rotate(${120}deg)` }} />
        )}
        
        </>
      )}

      {/* Eastern United States */}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Eastern UnitedStates' && selectedTerritory.territoryRuler === 'Player1'  && (
        <>
       
          {targetTerritories.includes(5) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '34%', left: '29%', zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-10}deg)` }} />
          )}
          {targetTerritories.includes(4) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '35%', left: '27%', zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${-80}deg)` }} />
          )}
           {targetTerritories.includes(6) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '37%', left: '25%', zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${220}deg)` }} />
          )}
          {targetTerritories.includes(8) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '41%', left: '24.5%', zIndex: 3, width: '5.5%', height: 'auto', transform: `rotate(${170}deg)` }} />
          )}
        </>
      )}

       {/* Central America */}

       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Central America' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
         
          {targetTerritories.includes(6) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '43%', left: '23.5%', zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-100}deg)` }} />
          )}

          {targetTerritories.includes(7) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '43%', left: '27%', zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-10}deg)` }} />
          )}

          {targetTerritories.includes(9) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '52%', left: '26%', zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${90}deg)` }} />
          )}

          {targetTerritories.includes(10) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '49.5%', left: '27%', zIndex: 3, width: '9%', height: 'auto', transform: `rotate(${70}deg)` }} />
          )}

        </>
      )}

      {/* Done Until Here*/}


       {/* Peru*/}

       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Peru' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          {targetTerritories.includes(8) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '57%', left: '31%', zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-83}deg)` }} />
          )}

          {targetTerritories.includes(10) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '59%', left: '34.5%', zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${-10}deg)` }} />
          )}
          {targetTerritories.includes(11) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '65%', left: '32.5%', zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${110}deg)` }} />
          )}
        </>
      )}

      {/* Brazil*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Brazil' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          {targetTerritories.includes(39) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '48%', left: '36.3%', zIndex: 3, width: '12%', height: 'auto', transform: `rotate(${-5}deg)` }} />
          )}
          {targetTerritories.includes(8) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '55%', left: '33%', zIndex: 3, width: '5.5%', height: 'auto', transform: `rotate(${-107}deg)` }} />
          )}
          {targetTerritories.includes(9) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '63%', left: '34%', zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${170}deg)` }} />
          )}
          {targetTerritories.includes(11) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '63%', left: '32.7%', zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${150}deg)` }} />
          )}
        </>
      )}

       {/* Argentina*/}

       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Argentina' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          {targetTerritories.includes(9) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '65%', left: '33%', zIndex: 3, width: '5.5%', height: 'auto', transform: `rotate(${-75}deg)` }} />
          )}
          {targetTerritories.includes(10) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '63%', left: '33.5%', zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${-35}deg)` }} />
          )}
        </>
      )}

        {/* Greenland*/}

        {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Greenland' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
        {targetTerritories.includes(2) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '15%', left: '27.5%', zIndex: 3, width: '13%', height: 'auto', transform: `rotate(${190}deg)` }} />
        )}
        {targetTerritories.includes(4) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '19%', left: '26.8%', zIndex: 3, width: '14%', height: 'auto', transform: `rotate(${-190}deg)` }} />
        )}
        {targetTerritories.includes(5) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '20%', left: "30.5%", zIndex: 3, width: '12%', height: 'auto', transform: `rotate(${150}deg)` }} />
        )}
        {targetTerritories.includes(13) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '16%', left: '38.5%', zIndex: 3, width: '10%', height: 'auto', transform: `rotate(${55}deg)` }} />
        )}
          
        </>
      )}

      {/* Iceland*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Iceland' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
        {targetTerritories.includes(12) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '19.2%', left: '41%', zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${-155}deg)` }} />
        )}
         {targetTerritories.includes(14) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23%', left: "45.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${150}deg)` }} />
         )}
          {targetTerritories.includes(15) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '22%', left: '49%', zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${55}deg)` }} />
          )}
          </>
      )}

      {/* GreatBritain*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Great Britain' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          
          {targetTerritories.includes(13) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '25%', left: '45.5%', zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${-40}deg)` }} />
          )}
          {targetTerritories.includes(15) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '27%', left: "47%", zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${370}deg)` }} />
          )}
          {targetTerritories.includes(17) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '31%', left: '46%', zIndex: 3, width: '3.5%', height: 'auto', transform: `rotate(${80}deg)` }} />
          )}

        </>
      )}

      {/* Scandinavia*/}

      { selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Scandinavia' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
        
        {targetTerritories.includes(13) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '22%', left: "47%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${220}deg)` }} />
        )}
        {targetTerritories.includes(14) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '24.8%', left: "46.55%", zIndex: 3, width: '6.3%', height: 'auto', transform: `rotate(${180}deg)` }} />
        )}
        {targetTerritories.includes(16) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "49.8%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${120}deg)` }} />
        )}
        {targetTerritories.includes(19) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23%', left: "52.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${50}deg)` }} />
        )}
        </>
      )}

      {/* NorthernEurope*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Northern Europe' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          {targetTerritories.includes(14) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '29%', left: "47%", zIndex: 3, width: '5.3%', height: 'auto', transform: `rotate(${220}deg)` }} />
          )}
          {targetTerritories.includes(15) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '27%', left: "50.5%", zIndex: 3, width: '4%', height: 'auto', transform: `rotate(${-70}deg)` }} />
          )}
          {targetTerritories.includes(17) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '31%', left: "48.3%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${180}deg)` }} />
          )}
          {targetTerritories.includes(18) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '32%', left: "51.2%", zIndex: 3, width: '3.5%', height: 'auto', transform: `rotate(${120}deg)` }} />
          )}
          {targetTerritories.includes(19) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28.5%', left: "52.2%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${30}deg)` }} />
          )}
          </>
      )}

      {/* WesternEurope*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Western Europe' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          {targetTerritories.includes(14) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '31.5%', left: "46.5%", zIndex: 3, width: '3.5%', height: 'auto', transform: `rotate(${-99}deg)` }} />
          )}
          {targetTerritories.includes(16) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '32%', left: "49%", zIndex: 3, width: '3.5%', height: 'auto', transform: `rotate(${0}deg)` }} />
          )}
          {targetTerritories.includes(18) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '34.5%', left: "49%", zIndex: 3, width: '3.5%', height: 'auto', transform: `rotate(${50}deg)` }} />
          )}
          {targetTerritories.includes(39) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '37%', left: "46.3%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${120}deg)` }} />
          )}
        </>
      )}

      {/* SouthernEurope*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Southern Europe' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
        
        {targetTerritories.includes(16) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '32%', left: "50%", zIndex: 3, width: '3.5%', height: 'auto', transform: `rotate(${-90}deg)` }} />
        )}
        {targetTerritories.includes(17) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '35%', left: "48%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-160}deg)` }} />
        )}
        {targetTerritories.includes(19) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28%', left: "52%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${350}deg)` }} />
        )}
        {targetTerritories.includes(22) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36%', left: "52.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${70}deg)` }} />
        )}
        {targetTerritories.includes(39) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '38%', left: "48.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${150}deg)` }} />
        )}
        {targetTerritories.includes(40) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '38%', left: "51.5%", zIndex: 3, width: '4.3%', height: 'auto', transform: `rotate(${120}deg)` }} />
        )}
        
        </>
      )}

      {/* Ukraine*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Ukraine' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
         
         {targetTerritories.includes(15) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '22%', left: "52.5%", zIndex: 3, width: '5.5%', height: 'auto', transform: `rotate(${245}deg)` }} />
         )}
          {targetTerritories.includes(16) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "52.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${180}deg)` }} />
          )}
          {targetTerritories.includes(18) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28%', left: "52.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${160}deg)` }} />
          )}
          {targetTerritories.includes(20) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '25%', left: "58%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${55}deg)` }} />
          )}
          {targetTerritories.includes(21) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '29%', left: "56%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${95}deg)` }} />
          )}
          {targetTerritories.includes(22) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '29%', left: "53%", zIndex: 3, width: '9%', height: 'auto', transform: `rotate(${130}deg)` }} />
          )}
        </>
      )}

      {/* Ural*/}

      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Ural' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
         
         {targetTerritories.includes(19) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '24%', left: "57%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${190}deg)` }} />
          )}
          {targetTerritories.includes(21) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "59.2%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${150}deg)` }} />
          )}
          {targetTerritories.includes(24) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "60%", zIndex: 3, width: '9%', height: 'auto', transform: `rotate(${120}deg)` }} />
          )}
          {targetTerritories.includes(25) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23.5%', left: "63.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${65}deg)` }} />
          )}
        </>
      )}


       {/* Afganistan*/}
    
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Afganistan' && selectedTerritory.territoryRuler === 'Player1' && (
        <>
          {targetTerritories.includes(19) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "57%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-90}deg)` }} />
          )}
          {targetTerritories.includes(20) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '27.5%', left: "61%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-50}deg)` }} />
          )}
          {targetTerritories.includes(22) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36%', left: "59%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${160}deg)` }} />
          )}
          {targetTerritories.includes(23) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '37%', left: "60%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${120}deg)` }} />
          )}
          {targetTerritories.includes(24) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '34%', left: "63%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${55}deg)` }} />
          )}
        </>
      )}
      
       {/* Middle East*/}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Middle East' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(18) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36%', left: "52.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-110}deg)` }} />
         )}
         {targetTerritories.includes(19) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '34%', left: "54.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-70}deg)` }} />
         )}
         {targetTerritories.includes(21) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '35%', left: "57.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-10}deg)` }} />
         )}
        {targetTerritories.includes(23) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '40%', left: "58%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${55}deg)` }} />
        )}
         {targetTerritories.includes(41) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '43%', left: "53.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${150}deg)` }} />
        )}
       
        </>
      )}

       {/* India*/}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'India' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(21) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36%', left: "59.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-100}deg)` }} />
           )}
           {targetTerritories.includes(22) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '42%', left: "58%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-150}deg)` }} />
           )}
          {targetTerritories.includes(24) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '39%', left: "64.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-10}deg)` }} />
          )}
            {targetTerritories.includes(33) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '44%', left: "65%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${55}deg)` }} />
        )}
        </>
      )}

      {/* China*/}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'China' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
    
        {targetTerritories.includes(20) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '32%', left: "62%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-80}deg)` }} />
        )}
        {targetTerritories.includes(21) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '34.5%', left: "61%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-120}deg)` }} />
        )}
        {targetTerritories.includes(23) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '40%', left: "62.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-200}deg)` }} />
        )}
        {targetTerritories.includes(27) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '35%', left: "65.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-10}deg)` }} />
        )}
       {targetTerritories.includes(25) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '32%', left: "64%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-40}deg)` }} />
        )}
        {targetTerritories.includes(33) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '40%', left: "65%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${75}deg)` }} />
        )}
       
        </>
      )}

      {/* Siberia*/}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Siberia' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
         {targetTerritories.includes(20) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '24%', left: "63%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-170}deg)` }} />
         )}
          {targetTerritories.includes(24) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '27%', left: "62.5%", zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${-220}deg)` }} />
          )}

          {targetTerritories.includes(26) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '25%', left: "67%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${60}deg)` }} />
          )}
         {targetTerritories.includes(27) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "65.25%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${90}deg)` }} />
         )}
        </>
      )}

       {/* SiberiaRight*/}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Siberia Right' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(25) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23.8%', left: "66%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-140}deg)` }} />
          )}
          {targetTerritories.includes(27) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '29%', left: "68%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-220}deg)` }} />
          )}
          {targetTerritories.includes(28) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28%', left: "71%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${80}deg)` }} />
          )}

        </>
      )}

       {/* ChinaTop */}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'China Top' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        
        {targetTerritories.includes(24) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36%', left: "67.25%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-230}deg)` }} />
        )}
        {targetTerritories.includes(25) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28.5%', left: "66%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-100}deg)` }} />
        )}
        {targetTerritories.includes(26) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28%', left: "69%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-45}deg)` }} />
        )}
        {targetTerritories.includes(28) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '31%', left: "71%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${20}deg)` }} />
        )}
        
        </>
      )}

      {/* Mangolia */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Mangolia' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        
        {targetTerritories.includes(26) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28%', left: "70%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-120}deg)` }} />
        )}
        {targetTerritories.includes(27) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '32%', left: "70.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-200}deg)` }} />
        )}
        {targetTerritories.includes(29) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '28.5%', left: "73%", zIndex: 3, width: '4.5%', height: 'auto', transform: `rotate(${-10}deg)` }} />
        )}
        {targetTerritories.includes(38) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '31%', left: "73.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${60}deg)` }} />
        )}
        </>
      )}

      {/* IRKLITSK */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'IRKLITSK' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(28) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '30%', left: "73.5%", zIndex: 3, width: '4.1%', height: 'auto', transform: `rotate(${-200}deg)` }} />
        )} 
        {targetTerritories.includes(30) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "76%", zIndex: 3, width: '4.1%', height: 'auto', transform: `rotate(${-0}deg)` }} />
        )}
       
        </>
      )}

      {/* IRKLITSKTop */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'IRKLITSK Top' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(29) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '26%', left: "75.5%", zIndex: 3, width: '4.1%', height: 'auto', transform: `rotate(${-200}deg)` }} />
        )}
        {targetTerritories.includes(31) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '21%', left: "76.5%", zIndex: 3, width: '4.1%', height: 'auto', transform: `rotate(${-60}deg)` }} />
        )}
        {targetTerritories.includes(32) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23%', left: "78%", zIndex: 3, width: '4.1%', height: 'auto', transform: `rotate(${-0}deg)` }} />
        )}
        
        </>
      )}

       {/* YAKLITSK */}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'YAKLITSK' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(30) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '22.5%', left: "76.25%", zIndex: 3, width: '3%', height: 'auto', transform: `rotate(${-210}deg)` }} />
        )}
        {targetTerritories.includes(32) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '21%', left: "78.5%", zIndex: 3, width: '4.1%', height: 'auto', transform: `rotate(${50}deg)` }} />
        )}
        </>
      )}

      {/* Kamchatka */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Kamchatka' && selectedTerritory.territoryRuler === 'Player1'  &&(
        <>
        {targetTerritories.includes(1) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23%', left: "80%", zIndex: 3, width: '40%', height: '5%', transform: `rotate(${5}deg)` }} />
         )}
        {targetTerritories.includes(1) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '23%', left: "-8%", zIndex: 3, width: '25%', height: '5%', transform: `rotate(${10}deg)` }} />
         )}
        {targetTerritories.includes(30) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '22.5%', left: "78%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-160}deg)` }} />
         )}
         {targetTerritories.includes(31) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '20%', left: "78.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-120}deg)` }} />
         )}

        </>
      )}

       {/* Slam */}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Slam' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(23) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '44%', left: "65%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-130}deg)` }} />
        )}
        {targetTerritories.includes(24) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '43%', left: "68%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-80}deg)` }} />
        )}

        {targetTerritories.includes(34) &&(
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '50%', left: "68.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-260}deg)` }} />
        )}
        </>
      )}

      {/* Indonesia */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Indonesia' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(35) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '55%', left: "73%", zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${30}deg)` }} />
        )}
        {targetTerritories.includes(37) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '61%', left: "71%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${90}deg)` }} />
        )}
        </>
      )}

       {/* NewGuinea */}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'New Guinea' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(34) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '56%', left: "73.5%", zIndex: 3, width: '9%', height: 'auto', transform: `rotate(${200}deg)` }} />
          )}
          {targetTerritories.includes(36) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '60%', left: "78.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${120}deg)` }} />
          )}
          {targetTerritories.includes(37) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '59.25%', left: "74.6%", zIndex: 3, width: '9%', height: 'auto', transform: `rotate(${170}deg)` }} />
          )}
        </>
      )}

      {/* EasternAustralia */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Eastern Australia' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(35) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '60%', left: "78.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-80}deg)` }} />
         )}
        {targetTerritories.includes(37) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '65%', left: "77%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${200}deg)` }} />
        )}
        </>
      )}

       {/* WesternAustralia */}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Western Australia' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(34) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '62.5%', left: "72.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${240}deg)` }} />
        )}
        {targetTerritories.includes(35) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '60%', left: "76%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-30}deg)` }} />
        )}
        {targetTerritories.includes(36) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '68%', left: "78%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${60}deg)` }} />
        )}
        </>
      )}

      {/* Japan */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Japan' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
        {targetTerritories.includes(28) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '33%', left: "75%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${240}deg)` }} />
        )}
        {targetTerritories.includes(29) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '30%', left: "76%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${270}deg)` }} />
        )}
        </>
      )}

       {/* NorthAfrica */}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'North Africa' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(10) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '45%', left: "35.8%", zIndex: 3, width: '15%', height: 'auto', transform: `rotate(${-180}deg)` }} />
          )}
           {targetTerritories.includes(17) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '38%', left: "45.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-70}deg)` }} />
          )}
          {targetTerritories.includes(18) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '38%', left: "47%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-20}deg)` }} />
          )}
          {targetTerritories.includes(40) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '41%', left: "48%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-340}deg)` }} />
         )}
         {targetTerritories.includes(41) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '44%', left: "48%", zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${-300}deg)` }} />
        )}
         {targetTerritories.includes(42) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '46%', left: "47%", zIndex: 3, width: '8%', height: 'auto', transform: `rotate(${-270}deg)` }} />
         )}
          </>
      )}

       {/* Egypt */}
       {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Egypt' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(18) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '36.5%', left: "51%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-70}deg)` }} />
          )}
          {targetTerritories.includes(39) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '43%', left: "49.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-180}deg)` }} />
          )}
          {targetTerritories.includes(41) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '45%', left: "52%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-250}deg)` }} />
          )}
        </>
      )}

      {/* EastAfrica */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'East Africa' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          
          {targetTerritories.includes(22) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '45%', left: "56%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${-50}deg)` }} />
           )}
          {targetTerritories.includes(39) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '45%', left: "51%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-130}deg)` }} />
           )}
          {targetTerritories.includes(40) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '43.5%', left: "53%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-100}deg)` }} />
          )}
           {targetTerritories.includes(42) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '50.5%', left: "52%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-170}deg)` }} />
           )}
           {targetTerritories.includes(43) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '54%', left: "52%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-200}deg)` }} />
           )}
          {targetTerritories.includes(44) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '52%', left: "54.5%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-250}deg)` }} />
          )}
        </>
      )}


      {/* Congo */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Congo' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(39) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '47%', left: "49.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-80}deg)` }} />
          )}
          {targetTerritories.includes(41) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '50%', left: "53%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${10}deg)` }} />
          )}
          {targetTerritories.includes(43) && (
            <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '56.5%', left: "51.25%", zIndex: 3, width: '7%', height: 'auto', transform: `rotate(${-250}deg)` }} />
          )}

        </>
      )}

      {/* SouthAfrica */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'South Africa' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(41) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '55%', left: "53%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-30}deg)` }} />
          )}
          {targetTerritories.includes(42) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '55%', left: "51%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-80}deg)` }} />
          )}
           {targetTerritories.includes(44) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '60.5%', left: "54.5%", zIndex: 3, width: '5%', height: 'auto', transform: `rotate(${30}deg)` }} />
          )}

        </>
      )}

      {/* Madgascar */}
      {selectedTerritory && currentPhase === 'Attack' && selectedTerritory.territoryName === 'Madgascar' && selectedTerritory.territoryRuler === 'Player1' &&(
        <>
          {targetTerritories.includes(41) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '55%', left: "55.25%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-80}deg)` }} />
          )}
          {targetTerritories.includes(43) && (
          <img src={arrowIndicator} alt="Arrow indicator" style={{ position: 'absolute', top: '59.25%', left: "53.5%", zIndex: 3, width: '6%', height: 'auto', transform: `rotate(${-150}deg)` }} />
          )}
        </>
      )}

      </div>

      {/* Target Arrows */}

      {/* Target Arrows */}

      {/* Elements positioned at bottom left */}
      {/* Move Phase Button */}
      {/*  <div style={{ position: 'absolute', bottom: 0, left: 0, padding: '10px', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>
        <div>Current Phase: {currentGameState !== 'COMBAT' ? currentGameState : currentPhase}</div>
        <div>Current Player Reserved Troops: {PlayersData[currentTurnPlayer - 1].reservedTroopsCount}</div>
        <div>Current Player Deployed Troops: {PlayersData[currentTurnPlayer - 1].deployedTroopsCount}</div>

        
        <button onClick={handleMovePhaseClick}>End Phase</button>

      </div> */}

      {/* Show Battle State */}
      <div>
        
        {<BattleScreen isVisible={showBattleScreen} onClose={handleCloseBattle} />}
      </div>

      {/* Show Battle State */}
      <div>
        {<ForFiet isVisible={showForfietScreen} onClose={handleCloseForfiet} />}
      </div> 

      <div>
        {/* Game board content */}
        {/* Render the SplashScreen component */}
        {<AIController isVisible={true} />}
      </div> 


      <div>
        {/* Game board content */}
        {/* Render the SplashScreen component */}
        {/* <SplashScreen isVisible={true} /> 8*/}
      </div>


      {/* Text Timer Animation */}
     
      <div style={{
        position: 'absolute',
        left: '35vw',
        top: '30vh',
        width: '100%',
        height: 'auto',
        fontSize: '3vw',
        color: 'white',
        fontWeight: 'bold',
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
        transform: `scale(${isAnimating ? 1 : 0})`,
        transition: 'transform 1s',
       
        zIndex: 10,
      }}>
        {animationMessage}
      </div>
    
      {/* region UI Design Icons Section */}

      {/* Left side Zoom Bar Image */}
      <div className="game_zoombar_div">
        <img
          src={zoomBar}
          alt="ZoomBar"
          style={{ width: "100%",  }}
          onClick={handleZoomIn}
        />
        <img
          src={zoomBarMinus}
          alt="ZoomBar"
          style={{ width: "100%",  }}
          onClick={handleZoomOut}
        />
      </div>


      {/* Buttons Menu in left bottom corner */}
      <div className="game_3button_div">
        <img
          src={flagBtn}
          alt="Button 1"
          style={{ width: "100%", height: "100%" }}
          onClick={handleForfiet}
        />

        <img
          src={settingBtn}
          alt="Button 2"
          style={{ width: "100%", height: "100%" }}
          onClick={handleSetting}
        />
        <img src={helpBtn} style={{ width: "100%", height: "100%" }} />
      </div>

      {/* Local Player Profile Bar */}

      {/* Player Selection Bar */}

      {(showReinForcementPopup || showAttackPopup || showFortifyPopup) && (
        <div className="player-selection-bar" style={{ position: 'absolute', top: '75%', left: '50%', transform: 'translateX(-50%)', width: '15%', height: '8%', zIndex: 100 }}>
          <div className="selection-bg" style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img src={selectionBG} alt="Centered Image" style={{ width: '100%', height: '100%' }} />
            <img src={descreaseeBtn} alt="Left Image" className="roll-btn left" style={{ position: 'absolute', top: '50%', left: '5%', transform: 'translate(-50%, -50%)', width: '20%', height: 'auto', zIndex: 4 }} onClick={handleTroopsCountDecrease} />
            <img src={increaseBtn} alt="Right Image" className="roll-btn right" style={{ position: 'absolute', top: '50%', right: '5%', transform: 'translate(50%, -50%)', width: '20%', height: 'auto', zIndex: 4 }} onClick={handleTroopsCountIncrease} />
            {(!showAttackPopup &&
              <img src={wrongBtn} alt="Wrong Image" className="wrong-btn left" style={{ position: 'absolute', top: '50%', left: '-20%', transform: 'translate(-50%, -50%)', width: '20%', height: 'auto', zIndex: 4 }} onClick={handleResetAction} />
            )}
            <img src={rightBtn} alt="Right Image" className="right-btn right" style={{ position: 'absolute', top: '50%', right: '-20%', transform: 'translate(50%, -50%)', width: '20%', height: 'auto', zIndex: 4 }} onClick={handleAction} />
            <div className="troops-text" style={{ position: 'absolute', bottom: '20%', left: '50%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '2vw', fontFamily: 'Gomarice' }}>
              {currentPhase === 'Reinforcement' ? reinforcementCount : currentPhase === 'Attack' ? attackCount : fortifyCount}
            </div>
          </div>
        </div>
      )}

      <div className="game_all_img_div">
        <img
          src={playerProfile}
          alt="Left Image"
          style={{
            width: "40%",
            position: "absolute",
            zIndex: "2",
            left: "-20%",
          }}
          // className="game_playeprofile"
        />
        <img
          src={playerProfileLevel}
          alt="Left Image"
          className="game_player_level"
        />
        <div className="game_plyare_level_font">
          {PlayersData[0].reservedTroopsCount}
        </div>
        <img
          src={phaseStatusSprite}
          alt="Phase Status Image"
          className="game_location_img"
        />
        <img
          src={profileHolderBG}
          alt="Centered Image"
          style={{ zIndex: 1, left: "10%", width: "80%", height: "50%" }}
        />
        <div
          className="game_inner_text"
          style={{
            position: "absolute",
            bottom:
              currentGameState === "COMBAT" && currentPhase === "Reinforcement"
                ? "-5%"
                : "-5%",
            left:
              currentGameState === "COMBAT" && currentPhase === "Reinforcement"
                ? "40%"
                : "52%",
            transform: "translateX(-50%)",
            zIndex: 4,
            fontWeight: "bold",
            color: "white",
            fontSize:
              currentGameState === "COMBAT" && currentPhase === "Reinforcement"
                ? "1.4vw"
                : "1.8vw",
            fontFamily: "Gomarice",
          }}
        >
          {currentGameState !== "COMBAT" ? currentGameState : currentPhase}
        </div>
        <img
          src={timerSpriteBG}
          alt="Timer Filler BG"
          className="game_timer_filer_bg"
        />
        <img
  src={timerSprite}
  alt="Timer Filler"
  className="game_timr_filler_div"
  style={{
    clipPath:
      currentTurnPlayer === 1
        ? `inset(0% ${
            currentGameState === "COMBAT"
              ? `${(phaseTimerValue - phaseTimer) * 3.25}%`
              : `${(claimPhaseTimer - phaseTimer) * 10}%`
          } 0% 0%)`
        : "inset(0% 0% 0% 0%)",
    transition: "clip-path 0.5s ease-in-out",
  }}
/>

        <img
          src={rightBtn}
          alt="Move Phase"
          style={{ width: "20%", position: "absolute", left: "85%" }}
          // className="move-phase-button game_rightarrow_img"

           onClick={handleMovePhaseClick}
        />
      </div>



      {/* Player Turn List */}
      {/* Player 1*/}
      <div style={{ position: 'absolute', top: '28%', right: '0%', width: '15%', height: '12%' }}>


        {currentTurnPlayer === 1 && (
        <img src={playerTurnBG} alt="player1TurnBG" style={{ width: '100%', height: '100%' }} />
        
        )}
        <img src={playerProfile} alt="Player Profile" style={{ position: 'absolute', top: '11%', right: '18%', zIndex: 3, width: '30%', height: '65%' }} />
        {currentTurnPlayer === 1 && (
        <img src={playerTimerClock} alt="Timer Clock" style={{ position: 'absolute', top: '13%', right: '65%', zIndex: 3, width: '15%', height: '35%' }} />
        )}
        {/* Timer Text */}
        {currentTurnPlayer === 1 && (
          <div style={{ position: 'absolute', top: '50%', left: '26%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '1.4vw', fontFamily: 'Gomarice', width: '25%', height: '65%' }}>
            {`00:${Math.floor(phaseTimer) < 10 ? '0' + Math.floor(phaseTimer) : Math.floor(phaseTimer)}`}
          </div>
        )}

      </div>

      {/* Player 2*/}
      <div style={{ position: 'absolute', top: '40%', right: 0, width: '15%', height: '12%' }}>


      {currentTurnPlayer === 2 && (
        <img src={player2TurnBG} alt="player1TurnBG" style={{ width: '100%', height: '100%' }} />
      )}
        <img src={player2Profile} alt="Player Profile" style={{ position: 'absolute', top: '11%', right: '18%', zIndex: 3, width: '30%', height: '65%' }} />
        {currentTurnPlayer === 2 && (
        <img src={playerTimerClock} alt="Timer Clock" style={{ position: 'absolute', top: '13%', right: '65%', zIndex: 3, width: '15%', height: '35%' }} />
        )}
        {/* Timer Text */}
        {currentTurnPlayer === 2 && (
          <div style={{ position: 'absolute', top: '50%', left: '26%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '1.4vw', fontFamily: 'Gomarice', width: '25%', height: '65%' }}>
            {`00:${Math.floor(phaseTimer) < 10 ? '0' + Math.floor(phaseTimer) : Math.floor(phaseTimer)}`}
          </div>
        )}

      </div>

      {/* Player 3*/}
      {playerCount && playerCount >= 3 && (
        <div style={{ position: 'absolute', top: '52%', right: 0, width: '15%', height: '12%', }}>


        {currentTurnPlayer === 3 && (
          <img src={player3TurnBG} alt="player1TurnBG" style={{ width: '100%', height: '100%' }} />
        )}
          <img src={player3Profile} alt="Player Profile" style={{ position: 'absolute', top: '11%', right: '18%', zIndex: 3, width: '30%', height: '65%' }} />
          {currentTurnPlayer === 3 && (
          <img src={playerTimerClock} alt="Timer Clock" style={{ position: 'absolute', top: '13%', right: '65%', zIndex: 3, width: '15%', height: '35%' }} />
          )}
          {/* Timer Text */}
          {currentTurnPlayer === 3 && (
            <div style={{ position: 'absolute', top: '50%', left: '26%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '1.4vw', fontFamily: 'Gomarice', width: '25%', height: '65%' }}>
              {`00:${Math.floor(phaseTimer) < 10 ? '0' + Math.floor(phaseTimer) : Math.floor(phaseTimer)}`}
            </div>
          )}

        </div>
      )}

      {/* Player 4*/}
      {playerCount && playerCount >= 4 && (
        <div style={{ position: 'absolute', top: '64%', right: 0, width: '15%', height: '12%', }}>


        {currentTurnPlayer === 4 && (
          <img src={player4TurnBG} alt="player1TurnBG" style={{ width: '100%', height: '100%' }} />
        )}
          <img src={player2Profile} alt="Player Profile" style={{ position: 'absolute', top: '11%', right: '18%', zIndex: 3, width: '30%', height: '65%' }} />
          {currentTurnPlayer === 4 && (
          <img src={playerTimerClock} alt="Timer Clock" style={{ position: 'absolute', top: '13%', right: '65%', zIndex: 3, width: '15%', height: '35%' }} />
          )}
          {/* Timer Text */}
          {currentTurnPlayer === 4 && (
            <div style={{ position: 'absolute', top: '50%', left: '26%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '1.4vw', fontFamily: 'Gomarice', width: '25%', height: '65%' }}>
              {`00:${Math.floor(phaseTimer) < 10 ? '0' + Math.floor(phaseTimer) : Math.floor(phaseTimer)}`}
            </div>
          )}

        </div>
      )}

      {/* Player 5*/}
      {playerCount && playerCount >= 5 && (
        <div style={{ position: 'absolute', top: '76%', right: 0, width: '15%', height: '12%', }}>



        {currentTurnPlayer === 5 && (
          <img src={player5TurnBG} alt="player1TurnBG" style={{ width: '100%', height: '100%' }} />
        )}
          <img src={player2Profile} alt="Player Profile" style={{ position: 'absolute', top: '11%', right: '18%', zIndex: 3, width: '30%', height: '65%' }} />
          {currentTurnPlayer === 5 && (
          <img src={playerTimerClock} alt="Timer Clock" style={{ position: 'absolute', top: '13%', right: '65%', zIndex: 3, width: '15%', height: '35%' }} />
          )}
          {/* Timer Text */}
          {currentTurnPlayer === 5 && (
            <div style={{ position: 'absolute', top: '50%', left: '26%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '1.4vw', fontFamily: 'Gomarice', width: '25%', height: '65%' }}>
              {`00:${Math.floor(phaseTimer) < 10 ? '0' + Math.floor(phaseTimer) : Math.floor(phaseTimer)}`}
            </div>
          )}

        </div>
      )}

      {/* Player 6*/}
      {playerCount && playerCount >= 6 && (
        <div style={{ position: 'absolute', top: '88%', right: 0, width: '15%', height: '12%', }}>

        {currentTurnPlayer === 6 && (
          <img src={player6TurnBG} alt="player1TurnBG" style={{ width: '100%', height: '100%' }} />
        )}
        
          <img src={player2Profile} alt="Player Profile" style={{ position: 'absolute', top: '11%', right: '18%', zIndex: 3, width: '30%', height: '65%' }} />
          {currentTurnPlayer === 6 && (
          <img src={playerTimerClock} alt="Timer Clock" style={{ position: 'absolute', top: '13%', right: '65%', zIndex: 3, width: '15%', height: '35%' }} />
          )}
          {/* Timer Text */}
          {currentTurnPlayer === 6 && (
            <div style={{ position: 'absolute', top: '50%', left: '26%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '1.4vw', fontFamily: 'Gomarice', width: '25%', height: '65%' }}>
              {`00:${Math.floor(phaseTimer) < 10 ? '0' + Math.floor(phaseTimer) : Math.floor(phaseTimer)}`}
            </div>
          )}

        </div>
      )}


     </div>
  );
};

export { PlayersDataExport }; // Export PlayersData
export { currentPhaseExport };

export { territoryBoardDataExport };
export { linkingTerritoriesExport };
export { currentTurnPlayerExport };

export {
  updateTerritoryDataExport, updatePlayerDataExport, movePhaseExport,
  setCurrentGameStateExport, attackerDiceNumberExport, defenderDiceNumberExport,
  removeTerritoryFromOtherPlayersExport, rollDiceExport, setAttackerDiceNumberExport,
  setDefenderDiceNumberExport, isLogModeOnExport, InitializeGameBoardExport, SetBattleResultDataExport,
  battleResultDataExport, playerProfile1, playerProfile2, playerProfile3, restoreAttackTimerExport, phaseTimerExport,
};

export default GameBoard;